import * as React from "react";

/**
 * react-hook-form 의 `field.ref` 를 실제 DOM 요소에 연결한다.
 *
 * `ref={field.ref}` 를 JSX 에 직접 넘기면 React Compiler 가 "렌더 중 ref 접근" 으로 보고
 * 그 컴포넌트의 컴파일을 포기한다(같은 객체에서 읽는 `field.value` 까지 함께 걸린다).
 * 그래서 로컬 ref 를 JSX 에 주고, 커밋 이후에 RHF 쪽으로 연결한다.
 *
 * deps 를 두지 않는 이유: 조회↔수정 모드 전환처럼 요소가 교체될 때도 다시 연결해야 한다.
 */
export function useFieldRef<T extends HTMLElement>(field: {
  ref: (instance: T | null) => void;
}) {
  const ref = React.useRef<T>(null);

  React.useEffect(() => {
    if (ref.current) field.ref(ref.current);
  });

  return ref;
}
